import React from "react"
import styled from "styled-components"
import { FlexSearchInput } from "../FlexSearchInput"

export const MobileFlexSearchModal = ({
  modalRef,
  searchedString,
  setSearchedString,
  isOpen,
}) => {
  return (
    <ModalWindow isOpen={isOpen}>
      <Backdrop ref={modalRef} isOpen={isOpen}>
        <DesktopHeaderSearchInput
          input={searchedString}
          onChange={setSearchedString}
          floatingResults
          dark
        />
      </Backdrop>
    </ModalWindow>
  )
}

const DesktopHeaderSearchInput = styled(FlexSearchInput)`
  @media (min-width: ${({ theme }) => theme.media.tablet_min}) {
    flex: 1 1 auto;
  }
}
`

const ModalWindow = styled.button`
  position: fixed;
  border: none;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 100;
  width: 100vw;
  transition: 0.3s ease-out;
  opacity: ${({ isOpen }) => (isOpen ? "1" : "0")};
  pointer-events: ${({ isOpen }) => (isOpen ? "auto" : "none")};

  @media (min-width: ${({ theme }) => theme.media.desktop_min}) {
    display: none;
  }
`

const Backdrop = styled.div`
  position: relative;
  top: 0;
  left: ${({ isOpen }) => (isOpen ? "0" : "-100%")};
  bottom: 0;
  min-width: 250px;
  width: 80%;
  background-color: white;
  z-index: 110;
  height: 100%;
  padding: 12px;
  transition: 0.5s ease-out;
`
